<template>
    <div>
        <h1>REST API</h1>
        <sui-grid>
            <sui-grid-row :columns="2">
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Access</h3>
                    <sui-segment attached>
                        <p>
                            <strong>Url</strong><br />https://n23ao6on11.execute-api.eu-central-1.amazonaws.com/prod<br />
                        </p>
                        <p><strong>Headers</strong><br/>
                        x-api-key: {{ apiKey }}<br/>
                        Authorization: SecretKey {{ secretKey }}
                        </p>
                        
                    </sui-segment>
                </sui-grid-column>
                <sui-grid-column>
                    <h3 is="sui-header" :color="online ? 'green' : (testing ? 'orange' : 'red')" attached="top"><sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refreshApiStatus()" size="mini" /> Status</h3>
                    <sui-segment  attached>
                        <div v-if="online">
                            API is online, response time is {{ responseMs }}ms.
                        </div>
                        <div v-else-if="testing">
                            Connecting to api ...
                        </div>
                        <div v-else>
                            Offline :(
                        </div>
                        
                    </sui-segment>

                    <h3 attached="top" is="sui-header"><sui-image src="/static/images/integromat-logo.png" size="mini" /> Integromat</h3>
                    <sui-segment  attached>
                        <p>
                            <sui-button positive content="Connect to integromat" @click="openIntegromat()" />
                        </p>
                        <h4>Connection parameters</h4>
                        <p>
                            apiKey: {{ apiKey }}<br>
                            secretKey: {{ secretKey }}<br>
                        </p>
                        
                    </sui-segment>
                    
                </sui-grid-column>
            </sui-grid-row>
            <sui-grid-row>
                <sui-grid-column>
                    <h3 is="sui-header" attached="top">Endpoints</h3>
                    <sui-segment attached>
                        <sui-accordion exclusive>
                            <div v-for="(endpoint, index) in endpoints" v-bind:key="index">
                                <sui-accordion-title>
                                    <sui-icon name="dropdown" />
                                    <sui-label :color="endpoint.method == 'GET' ? 'blue' : (endpoint.method == 'POST' ? 'orange' : 'grey')" size="mini" horizontal>{{ endpoint.method }}</sui-label> {{ endpoint.url }}
                                </sui-accordion-title>
                                <sui-accordion-content>
                                    <p>{{ endpoint.description }}</p>
                                </sui-accordion-content>
                            </div>
                        
                      </sui-accordion>
                        
                    </sui-segment>
                </sui-grid-column>
            </sui-grid-row>
            
        </sui-grid>
  </div>
</template>

<script>
import DziService from '@/DziService'

export default {
  name: 'ApiInfo',
  data() {
    return {
        online: false,
        testing: false,
        responseStart: null,
        responseEnd: null,
        apiKey: null,
        secretKey: null,
        endpoints: [
            {
                method: 'GET',
                url: '/device',
                description: 'List all devices under your account'
            },
            {
                method: 'GET',
                url: '/device/<id>',
                description: 'Device info'
            },
            {
                method: 'GET',
                url: '/device/<id>/history',
                description: 'Device history'
            },
            {
                method: 'GET',
                url: '/device/<id>/<timestamp>',
                description: 'Info about deactivated device'
            },
            {
                method: 'GET',
                url: '/alias',
                description: 'List all channels under your account'
            },
            {
                method: 'GET',
                url: '/alias/<channel>',
                description: 'Info about channel'
            },
            {
                method: 'GET',
                url: '/alias/<channel>/history',
                description: 'Channel history'
            }
        ]
    }
  },
  computed: {
    responseMs() {
        return this.responseEnd - this.responseStart;
    }
},
  methods: {
      openIntegromat()
      {
        window.open('https://www.integromat.com/en/apps/invite/051d13a1e8ad6619d145274bae91a41b', '_blank');
      },
    refreshApiStatus()
    {                 
        this.online = false;
        this.testing = true;
        this.responseStart = (new Date()).getTime();
        DziService.ping().then(() => {
            this.testing = false;
            this.responseEnd = (new Date()).getTime();
            this.online = true;
            
        }).catch(error => {
            this.testing = false;
            this.online = false;
            this.onlineError = error;
            
        })
    },
    loadCurrentClient()
    {
        DziService.getCurrentClient().then(result => {
            this.apiKey = result.data.apiKey;
            this.secretKey = result.data.secretKey;
        }).catch(error => {
            this.$store.commit('setError', 'Can\'t load current client: ' + error);
        })
    }
  },
  mounted () {
    this.loadCurrentClient();
    this.refreshApiStatus();
    
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
